import React from 'react'
import { object, string } from 'prop-types'

class LoungeInformation extends React.Component {
  createList (items) {
    if (Array.isArray(items)) {
      return items.map((item, key) => {
        if (item) return <li key={key}>{ item }</li>
      })
    } else {
      return Object.keys(items).map((item, key) => {
        if (items[item]) return <li key={key}>{ item }</li>
      })
    }
  }

  render () {
    const { id, productData, formSettings = {} } = this.props
    if (!productData || Object.keys(productData).length === 0) return null
    let {
      childrenpermitted,
      childrenPermitted,
      terminal,
      terminals,
      openingtime,
      closingtime,
      closingtime_exceptions: closingTimeExceptions,
      times,
      why_bookone: whyBookOne,
      why_booktwo: whyBookTwo,
      why_bookthree: whyBookThree,
      sellingTexts,
      name,
      prices,
      facilities,
      features = {},
      children_allowed,
      disabled_access,
      flight_announcements,
      smoking_permitted,
      free_drinks,
      free_snacks,
      internet,
      phone,
      tv,
      wifi,
      dresscode,
      dressCode,
      sellpoints,
      foodandbeverage,
      businessfacilities,
      facilitiesdisabled,
      disabledFacilities,
      entertainment_facilities: entertainmentFacilities,
      directions
    } = productData
    let startDate, lowestPrice, dateUsed
    if (prices && typeof prices === 'object') {
      startDate = prices.startDate
      lowestPrice = prices.lowestPrice
      dateUsed = prices.dateUsed
    }
    if (dressCode) dresscode = dressCode
    if (childrenPermitted) childrenpermitted = childrenPermitted
    if (disabledFacilities) facilitiesdisabled = disabledFacilities
    if (!times) {
      times = {
        closing: closingtime,
        opening: openingtime
      }
    }
    if (sellpoints) {
      if (!foodandbeverage) foodandbeverage = sellpoints.foodBeverage
      if (!businessfacilities) businessfacilities = sellpoints.businessFacilities
      if (!entertainmentFacilities) entertainmentFacilities = sellpoints.entertainmentFacilities
    }

    const lang = formSettings.language || 'en'

    const titleTranslations = {
      whyBookTitle: { en: 'Reasons to book', de: 'Gründe zu buchen', it: 'Motivi per prenotare' },
      loungeFacilitiesTitle: { en: 'Lounge Facilities', de: 'Ausstattung', it: 'Arredo lounge' },
      openingTimesTitle: { en: 'Opening times', de: 'Öffnungszeiten', it: 'Orari di apertura' },
      childrenPermittedTitle: { en: 'Children permitted', de: 'Kinder Willkommen', it: 'Bambini ammessi' },
      dresscodeTitle: { en: 'Dresscode', de: 'Dress-Code', it: 'Codice di abbigliamento' },
      foodAndDrinkTitle: { en: 'Food and drink', de: 'Verpflegung', it: 'Cibo e bevande' },
      entertainmentFacilitiesTitle: { en: 'Entertainment facilities', de: 'Unterhaltung', it: 'Intrattenimento' },
      disabledFacilitiesTitle: { en: 'Disabled facilities', de: 'Behindertengerechte Ausstattung', it: 'Servizi per disabili' },
      businessFacilitiesTitle: { en: 'Business facilities', de: 'Business Ausstattung', it: 'Servizi per il business' },
      directionsTitle: { en: 'Directions', de: 'Wegbeschreibung', it: 'Direzione' },
      priceTitle: { en: 'Price', de: 'Preis', it: 'Prezzo' },
      otherPagesRelated: { en: 'Check out other pages related to', de: 'Weitere Produkte:', it: 'Altri prodotti' },
      openTime: { en: `Open: ${openingtime}`, de: `Öffnet um: ${openingtime}`, it: `Apertura: ${openingtime}` },
      closeTime: { en: `Close: ${closingtime}`, de: `Schließt um: ${closingtime}`, it: `Chiusura: ${closingtime}` },
      adultPriceTitle: { en: 'Adult', de: 'Erwachsene', it: 'Adulti' },
      adultPrice: { en: `£${lowestPrice}`, de: `€${lowestPrice}`, it: `€${lowestPrice}` },
      priceSearchInfo: { en: `Date valid for ${startDate} booking, checked on ${dateUsed}`, de: `gültig bei Buchung für den ${startDate}, geprüft am ${dateUsed}`, it: `valido per la prenotazione per il giorno ${startDate}, controllato ${dateUsed}` },
      childrenAllowed: { en: 'Children allowed', de: 'Kinder Willkommen', it: 'bambini ammessi' },
      disabledAccess: { en: 'Disabled access', de: 'Barrierefreiheit', it: 'Accesso per disabili' },
      flightAnnouncements: { en: 'Flight announcements', de: 'Flug-Anzeige', it: 'Informazioni sui voli' },
      smokingPermitted: { en: 'Smoking permitted', de: 'Rauchen gestattet', it: 'È consentito fumare' },
      magazines: { en: 'Magazines', de: 'Zeitschriften' },
      airConditioning: { en: 'Air Conditioning', de: 'Klimaanlage' },
      freeDrinks: { en: 'Free drinks', de: 'Gratis Getränke', it: 'Bevande gratuite' },
      freeSnacks: { en: 'Free snacks', de: 'Gratis Snacks', it: 'Snack gratuiti' },
      internet: { en: 'Internet', de: 'Internetzugang', it: 'Accesso a internet' },
      phone: { en: 'Phone', de: 'Telefon', it: 'Telefono' },
      tv: { en: 'TV', de: 'TV', it: 'TV' },
      wifi: { en: 'Wifi', de: 'WLAN', it: 'Wifi' }
    }

    let whyBook = null
    if (sellingTexts && sellingTexts.length) whyBook = this.createList(sellingTexts)
    else whyBook = this.createList([whyBookOne, whyBookTwo, whyBookThree])
    const loungeFacilities = this.createList({
      [titleTranslations.childrenAllowed[lang]]: children_allowed || features.childrenAllowed,
      [titleTranslations.disabledAccess[lang]]: disabled_access || features.disabledAccess,
      [titleTranslations.flightAnnouncements[lang]]: flight_announcements || features.flightAnnouncements,
      [titleTranslations.smokingPermitted[lang]]: smoking_permitted || features.smokingPermitted,
      [titleTranslations.freeDrinks[lang]]: free_drinks || features.drinks,
      [titleTranslations.airConditioning[lang]]: features.airConditioning,
      [titleTranslations.magazines[lang]]: features.magazines,
      [titleTranslations.freeSnacks[lang]]: free_snacks || features.snacks,
      [titleTranslations.internet[lang]]: internet || features.internet,
      [titleTranslations.phone[lang]]: phone || features.phone,
      [titleTranslations.tv[lang]]: tv || features.tv,
      [titleTranslations.wifi[lang]]: wifi || features.wifi
    })

    const otherPagesRelatedLink = formSettings.language === 'de'
      ? `/de/suchen.html?search=${name}&ignore=true`
      : `https://www.holidayextras.co.uk/search.html?search=${name}&ignore=true`

    return (
      <div id={id} className='loungeInformation'>
        { whyBook && (
          <div>
            <h3>{titleTranslations.whyBookTitle[lang]}</h3>
            <ul>{ whyBook }</ul>
          </div>
        )}

        { loungeFacilities && (
          <div>
            <h3>{titleTranslations.loungeFacilitiesTitle[lang]}</h3>
            { facilities && (
              <p>The {name} features {facilities}</p>
            )}
            <ul>{ loungeFacilities }</ul>
          </div>
        )}

        { prices && lowestPrice && startDate && dateUsed && (
          <div>
            <h3>{titleTranslations.priceTitle[lang]}</h3>
            <p><strong>{titleTranslations.adultPriceTitle[lang]}</strong>: <span className='priceSmall'>{titleTranslations.adultPrice[lang]} *</span></p>
            <p><small>*{titleTranslations.priceSearchInfo[lang]}</small></p>
          </div>
        )}

        { times.opening && times.closing && (
          <div>
            <h3>{titleTranslations.openingTimesTitle[lang]}</h3>
            <p>{titleTranslations.openTime[lang]}<br />{titleTranslations.closeTime[lang]}</p>
            {closingTimeExceptions && <p>{closingTimeExceptions}</p>}
          </div>
        )}

        { (terminal || terminals) && (
          <div>
            <h3>Terminal</h3>
            <p>{terminal || terminals.join(', ')}</p>
          </div>
        )}

        { childrenpermitted && (
          <div>
            <h3>{titleTranslations.childrenPermittedTitle[lang]}</h3>
            <p dangerouslySetInnerHTML={{ __html: childrenpermitted }} />
          </div>
        )}

        { dresscode && (
          <div>
            <h3>{titleTranslations.dresscodeTitle[lang]}</h3>
            <p dangerouslySetInnerHTML={{ __html: dresscode }} />
          </div>
        )}

        { foodandbeverage && (
          <div>
            <h3>{titleTranslations.foodAndDrinkTitle[lang]}</h3>
            <p dangerouslySetInnerHTML={{ __html: foodandbeverage }} />
          </div>
        )}

        { entertainmentFacilities && (
          <div>
            <h3>{titleTranslations.entertainmentFacilitiesTitle[lang]}</h3>
            <p dangerouslySetInnerHTML={{ __html: entertainmentFacilities }} />
          </div>
        )}

        { facilitiesdisabled && (
          <div>
            <h3>{titleTranslations.disabledFacilitiesTitle[lang]}</h3>
            <p dangerouslySetInnerHTML={{ __html: facilitiesdisabled }} />
          </div>
        )}

        { businessfacilities && (
          <div>
            <h3>{titleTranslations.businessFacilitiesTitle[lang]}</h3>
            <p dangerouslySetInnerHTML={{ __html: businessfacilities }} />
          </div>
        )}

        { directions && (
          <div className='directions'>
            <h3>{titleTranslations.directionsTitle[lang]}</h3>
            <p dangerouslySetInnerHTML={{ __html: directions }} />
          </div>
        )}

        { name && (
          <div>
            <p>{titleTranslations.otherPagesRelated[lang]} <a href={otherPagesRelatedLink}>{name}</a></p>
          </div>
        )}

      </div>
    )
  }
}

LoungeInformation.propTypes = {
  productData: object,
  id: string
}

export default LoungeInformation



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/specificProduct/loungeInformation.jsx